/**
 * @generated SignedSource<<d0db1260a03bed4be0db8133b5404240>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RenderChildRowsComp$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Rows0BadPattern">;
  readonly " $fragmentType": "RenderChildRowsComp";
};
export type RenderChildRowsComp$key = {
  readonly " $data"?: RenderChildRowsComp$data;
  readonly " $fragmentSpreads": FragmentRefs<"RenderChildRowsComp">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "RenderChildRowsComp",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Rows0BadPattern"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "9ad3f787b5c83e6b8a67a4093393409f";

export default node;
